import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';

import { Rule } from '../../models/rule.model';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { selectPagedRules } from '../../store/selectors/rules.selector';
@Component({
  selector: 'app-health-indicator',
  templateUrl: './health-indicator.component.html',
  styleUrl: './health-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HealthIndicatorComponent implements OnInit, OnDestroy {
  pagedRules: Rule[] = [];
  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store
      .select(selectPagedRules)
      .pipe(takeUntil(this.destroy$))
      .subscribe((items) => {
        this.pagedRules = items as Rule[];
      });
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
